import type { CaseDetail } from '@/types/domain'

import { CargoCard } from './CargoCard'
import { ContainersCard } from './ContainersCard'
import { DetailsCard } from './DetailsCard'
import { RouteCard } from './RouteCard'

/* The overview is FR-24 read back: the route with the shipment's position on
 * it, the declared cargo against what the border scale said, the container and
 * seal pairs, and the deal terms. Four cards, one question each — "where is
 * it", "what is it", "which boxes", "on what terms" — so the founder's first
 * glance and the operator's daily check read the same surface. */

export function OverviewSection({ record }: { record: CaseDetail }) {
  const route = record.route ?? []

  return (
    <div className="flex flex-col gap-4">
      {route.length > 0 ? <RouteCard record={record} /> : null}

      <div className="grid items-start gap-4 lg:grid-cols-2">
        {record.cargo ? <CargoCard cargo={record.cargo} /> : null}
        <ContainersCard containers={record.containers} />
      </div>

      <DetailsCard record={record} />
    </div>
  )
}

